import {
  Swiper, Navigation, Scrollbar,
} from 'swiper';

const swiperContainerClass = '.sticky-column__slides .swiper-container';
const swiperContainerMobileClass = '.sticky-column__slider .swiper-container';
const swiperControls = '.sticky-column__nav';

function initStickyColumnSliders(container) {
  // eslint-disable-next-line no-new
  new Swiper(container, {
    loop: true,
    allowTouchMove: false,
    modules: [Navigation],
    spaceBetween: 20,
    navigation: {
      nextEl: `${container} .sticky-column__nav--next`,
      prevEl: `${container} .sticky-column__nav--prev`,
    },
    on: {
      afterInit() {
        if (this.el.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)').length === 1) {
          this.unsetGrabCursor();
          this.disable();
        }
      },
      orientationchange() {
        this.update();
      },
    },
  });

  const controls = document.querySelectorAll(swiperControls);
  controls.forEach((el) => el.addEventListener('click', (e) => e.preventDefault()));
}

function initStickyColumnMobileSliders(container) {
  // eslint-disable-next-line no-new
  new Swiper(container, {
    loop: false,
    grabCursor: true,
    spaceBetween: 20,
    modules: [Scrollbar],
    updateOnWindowResize: true,
    scrollbar: {
      el: '.swiper-scrollbar',
      draggable: true,
    },
    on: {
      afterInit() {
        if (this.el.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)').length === 1) {
          this.unsetGrabCursor();
          this.disable();
        }
      },
      orientationchange() {
        this.update();
      },
    },
  });

  const controls = document.querySelectorAll(swiperControls);
  controls.forEach((el) => el.addEventListener('click', (e) => e.preventDefault()));
}

document.addEventListener('DOMContentLoaded', () => {
  if (window.acf) {
    window.acf.addAction('render_block_preview/type=azds/sticky-column', ($block) => {
      initStickyColumnSliders($block.find(swiperContainerClass)[0]);
      initStickyColumnMobileSliders($block.find(swiperContainerMobileClass)[0]);
    });
  } else {
    initStickyColumnSliders(swiperContainerClass);
    initStickyColumnMobileSliders(swiperContainerMobileClass);
  }
});
